import styled from "styled-components";
import {
  OVERHANG_COLOR,
  OVERHANG_INVALID_COLOR,
  type FrontOverhangMarker,
} from "./frontOverhangView";

const Badge = styled.span<{ $outline: boolean; $invalid: boolean }>`
  position: absolute;
  right: 1px;
  top: ${({ $outline }) => ($outline ? "100%" : "1px")};
  z-index: 5;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid ${({ $invalid }) => ($invalid ? OVERHANG_INVALID_COLOR : OVERHANG_COLOR)};
  border-radius: 3px;
  background: ${({ $outline, $invalid }) =>
    $outline ? "white" : $invalid ? OVERHANG_INVALID_COLOR : OVERHANG_COLOR};
  color: ${({ $outline, $invalid }) =>
    $outline ? ($invalid ? OVERHANG_INVALID_COLOR : OVERHANG_COLOR) : "white"};
  font: 10px/14px sans-serif;
  padding: 0 3px;
  pointer-events: none;
`;

export const FrontOverhangBadge = ({
  marker,
  outline = false,
}: {
  marker: FrontOverhangMarker | null;
  outline?: boolean;
}) =>
  marker ? (
    <Badge
      $outline={outline}
      $invalid={marker.invalid}
      title={marker.description}
      aria-label={marker.description}
    >
      {marker.label}
    </Badge>
  ) : null;
